/*
  Lightweight analytics wiring. Fires the same event to both providers the site
  already loads: Umami (analytics.blkstr.io) and PostHog. No-ops if neither is present.
*/
export function track(event, props = {}) {
  try {
    if (window.umami && typeof window.umami.track === "function") window.umami.track(event, props);
  } catch (_) {}
  try {
    if (window.posthog && typeof window.posthog.capture === "function") window.posthog.capture(event, props);
  } catch (_) {}
}

// The funnel events we care about, surfaced in the admin Analytics tab.
export const TRACKED_EVENTS = [
  ["book_a_call", "Primary conversion. Any 'Book a call' CTA click (carries a `location`)."],
  ["pathway_check_open", "Pathway check opened from a landing-page CTA."],
  ["pathway_check_step", "A pathway check step was completed."],
  ["pathway_check_complete", "Pathway check completed before booking (carries lead tier and key routing fields)."],
  ["pathway_check_close", "Pathway check closed before or after completion."],
  ["get_the_guide", "Carousel CTA / guide click."],
  ["cta_click", "Any other tracked CTA click (carries `href` + `label`)."],
  ["socials_view", "A visit to the public /socials carousel page."],
  ["hook_variant_select", "Admin: a card-1 hook variant chosen for split-testing."],
  ["card_download", "Admin: a social card exported as PNG (carries `card` + `theme`)."],
];
